export class Class {
    constructor(name: string, description?: string, id?: number, studentIds?: number[]) {
        this.name = name;
        this.description = description;
        this.id = id || 0;
        this.studentIds = studentIds;
    }

    public id: number;
    public name: string;
    public description?: string = undefined;
    public studentIds?: number[];
}
